import { render, staticRenderFns } from "./wxmpUserList.vue?vue&type=template&id=2ac6642c&scoped=true"
import script from "./wxmpUserList.vue?vue&type=script&lang=js"
export * from "./wxmpUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac6642c",
  null
  
)

export default component.exports